// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-54d6f6c2],.login[data-v-54d6f6c2]{min-height:100vh}.bg-image[data-v-54d6f6c2]{background-image:url(https://res.cloudinary.com/dxfq3iotg/image/upload/v1561631318/img-123.jpg);background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
